<template>
  <div id="home" v-bind:class="{
    classPopup: showPopup
  }" @click="hideListGenres">
    <HomeNav />
    <section class="detail-block">
      <div class="container">
        <div class="row d-flex">
          <div class="mr-auto">
            <h3 class="font-semibold float-left">My List</h3>
          </div>
        </div>
      </div>
      <div class="container-fluid mt-5">
        <div class="d-flex flex-wrap justify-content-center">
          <div class="col-desktop" v-for="(item, index) in items" :key="index">
            <div class="series-block withhover" @click="goToPlayer(item)">
              <img class="img-fluid" :src="item.thumbnail.large" alt="" />
              <div class="more-cnt text-center">
                <h5 class="pt-3">{{ item.name }}</h5>
                <p class="py-2" v-if="item.metaData.running_time">Duration {{ item.metaData.running_time }}</p>
                <p>PG13</p>
                <p class="py-3">{{ item.description | trim }}</p>
                <div class="d-flex justify-content-between">
                  <a class="border circle-Sm" @click="voteVideo(item, true)">
                    <img class="like" src="../../assets/img/like.svg" alt="" />
                  </a>
                  <a class="border circle-Sm" @click="voteVideo(item, false)">
                    <img class="unlike" src="../../assets/img/unlike.svg" alt="" />
                  </a>
                  <a class="border circle-Sm" @click="toggleFavorited(item)">
                    <img src="../../assets/img/minis-icon.svg" v-if="my_favourite(item)" alt="" class="plus-icon" />
                    <img class="plus-icon" src="../../assets/img/plus.svg" v-else />
                  </a>
                </div>
                <div class="py-3 d-flex justify-content-center">
                  <a @click="playvideo(item)" class="d-inline-block">
                    <img src="../../assets/img/play.svg" class="play" alt="" />
                  </a>
                </div>

                <div class="pt-2 d-flex justify-content-center">
                  <a @click="goToDetails(item)" class="d-inline-block btn btn-outline-light">
                    More
                    <i class="fa fa-angle-right ml-2" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HomeNav from "@/components/HomeNav.vue";
import Helpers from "../../Mixins/Helpers.js";
export default {
  name: "ListMyList",
  components: {
    HomeNav,
  },
  filters: {
    trim: function (value) {
      if (value.length > 100) {
        return value.substring(0, 100) + "...";
      } else {
        return value;
      }
    },
  },
  mixins: [Helpers],
  mounted() {
    window.scroll(0, 0);
  },
  data() {
    return {
      items: [],
      showGenres: false,
      showUpdatePopUp: false,
      nocontent: false,
      duidVal: null
    };
  },
  methods: {
    goToDetails(current) {
      var dynamicRoute = "";
      if (current.type == "vod") {
        dynamicRoute = "/details/" + current.id + "/mylist";
      } else if (current.type == "Season") {
        dynamicRoute = "/playlistdetails/" + current.id;
      }

      this.$router.push("" + dynamicRoute);
    },
    goToPlayer(video) {
      if (this.isPlatformMobile() == true || this.isPlatformTablet() == true) {
        this.goToDetails(video);
      }
    },
    playvideo(current) {
      this.checkSubs(current);
    },

    checkSubs(current) {
      this.$store
        .dispatch("getVideoPlaybackURLV2", {
          videoId: current.id,
          deviceId: this.duidVal,
        })
        .then((res) => {
          if (current.type == "Series") {
            var currentCat = current.id;
            this.$store.dispatch("getCatalougeById", currentCat).then((res) => {
              var currentSeason = res._embedded.items[0].id;
              this.$store
                .dispatch("getCatalougeById", currentSeason)
                .then((res) => {
                  var currentSeasonVideoId = res._embedded.items[0].id;
                  var dynamicRoute = "/viewvideo/" + currentSeasonVideoId;
                  this.$router.push("" + dynamicRoute);
                });
            });
          } else {
            var dynamicRoute = "/viewvideo/" + current.id;
            this.$router.push("" + dynamicRoute);
          }
        })
        .catch((err) => {
          if (err.response.data.error.status == "422") {
            // show upgrade screen popup
          }
          if (err.response.data.error.status == "403") {
            this.$store.commit("showPopup", true);
            this.$store.commit("showdefaultFooter", false)
            window.scrollTo(0, 0);
          }
          if (err.response.data.error.status == "404 ") {
            this.$store.commit("showPopup", true);
            // this.$store.commit("setNotification", "Please try again later ");
            window.scrollTo(0, 0);
          }
          this.$store.commit("setLoader", false);
        });
    },

    voteVideo(show, status) {
      this.$store
        .dispatch("voteVideo", {
          id: show.id,
          status: status,
        })
        .then(() => { });
    },
    my_favourite(show) {
      for (var i = 0; i < this.$store.state.user.mylist.length; i++) {
        var item = this.$store.state.user.mylist[i];
        if (item.id == show.id) return true;
      }
      return false;
    },
    toggleFavorited(show) {
      var self = this;
      this.$store.commit("refreshMyList", false);
      if (this.my_favourite(show)) {
        this.$store
          .dispatch("updatemyList", {
            id: show.id,
            value: false,
            type: show.type,
          })
          .then(() => {
            self.items = self.myListItems;
          });
      } else {
        this.$store
          .dispatch("updatemyList", {
            id: show.id,
            value: true,
            type: show.type,
          })
          .then(() => {
            self.items = self.myListItems;
          });
      }
    },
    sortOne() {
      this.items.sort(function (a, b) {
        var titleA = a.name.toLowerCase(),
          titleB = b.name.toLowerCase();
        if (titleA < titleB) return -1;
        if (titleA > titleB) return 1;
        return 0;
      });
    },
    sortTwo() {
      this.items.sort(function (a, b) {
        var titleA = a.name.toLowerCase(),
          titleB = b.name.toLowerCase();
        if (titleA > titleB) return -1;
        if (titleA < titleB) return 1;
        return 0;
      });
    },
    showListGenres(ev) {
      ev.preventDefault();
      this.showGenres = true;
    },
    hideListGenres() {
      this.showGenres = false;
    },
    hideUpdatephone() {
      this.showUpdatePopUp = false;
    },
  },
  computed: {
    myListItems() {
      return this.$store.state.user.mylist;
    },
    isFavorited(show) {
      for (var i = 0; i < this.$store.state.user.mylist.length; i++) {
        var item = this.$store.state.user.mylist[i];
        if (item.id == show.id) return true;
      }
      return false;
    },
    showfav() {
      if (this.$store.state.user.mylist.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    showPopup() {
      return this.$store.state.showPopup;
    },
  },
  created() {
    self = this;
    this.$store.commit("showPopup", false);
    this.$store.commit("showdefaultnav", false);
    this.$store.commit("showdefaultFooter", true);
    this.$store.commit("setLoader", true);
    if (this.$store.state.user.logedin == false) {
      this.$store.commit("setLoader", false);
      this.$router.push("/login");
      return false;
    }

    this.items = this.myListItems;
    this.$store.commit("setLoader", false);
  },
};
</script>

<style scoped>
a,
button {
  cursor: pointer;
}

.home-card {
  padding-top: 70px;
  position: relative;
  margin: 0 auto;
  max-width: 80%;
  width: 80%;
}

.no-content {
  text-align: center;
  padding: 50px;
  color: #fff;
}

.owl-nav .disabled {
  display: none;
}

.cp {
  cursor: pointer !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.detail-block {
  min-height: 80vh;
}

.classPopup {
  position: fixed;
}
</style>
